import { oauth } from "../utils";

import { createAddTemp, createDeleteTemp } from "./temp";
import { closePopup, createErrorPopup, createNoticePopup } from "./popup";
import { getItemVariantsSuccess } from "./item";

export const UPDATE_SHOP_REQUEST = "UPDATE_SHOP_REQUEST";
export const UPDATE_SHOP_SUCCESS = "UPDATE_SHOP_SUCCESS";
export const UPDATE_SHOP_FAILURE = "UPDATE_SHOP_FAILURE";

export const LOAD_SHOP_SUCCESS = "LOAD_SHOP_SUCCESS";

export const EDIT_CHECKOUT = "EDIT_CHECKOUT";

export const UPDATE_PRODUCT_QUESTION = "UPDATE_PRODUCT_QUESTION";

export const EDIT_CART_ITEM = "EDIT_CART_ITEM";
export const UPDATE_CART_BREAKDOWN = "UPDATE_CART_BREAKDOWN";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const CLEAN_CART = "CLEAN_CART";
export const EMPTY_CART = "EMPTY_CART";
export const SET_CART = "SET_CART";

export const CREATE_CHECKOUT_REQUEST = "CREATE_CHECKOUT_REQUEST";
export const CREATE_CHECKOUT_SUCCESS = "CREATE_CHECKOUT_SUCCESS";
export const CREATE_CHECKOUT_FAILURE = "CREATE_CHECKOUT_FAILURE";

export const DELETE_SHOP_FAILURE = "DELETE_SHOP_FAILURE";

export const CREATE_FETCH_PUBLIC_VIEW_TEMPLATES =
  "CREATE_FETCH_PUBLIC_VIEW_TEMPLATES";
export const UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_REQUEST =
  "UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_REQUEST";
export const UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS =
  "UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS";
export const UPDATE_PUBLIC_VIEW_TEMPLATE_DATAS_SUCCESS =
  "UPDATE_PUBLIC_VIEW_TEMPLATE_DATAS_SUCCESS";
export const UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_FAILURE =
  "UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_FAILURE";

export const UPDATE_PUBLIC_VIEW_TEMPLATE_SUCCESS =
  "UPDATE_PUBLIC_VIEW_TEMPLATE_SUCCESS";
export const DELETE_PUBLIC_VIEW_TEMPLATE_SUCCESS =
  "DELETE_PUBLIC_VIEW_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";

export const DELETE_PUBLIC_VIEW_TEMPLATE_DATA_REQUEST =
  "DELETE_PUBLIC_VIEW_TEMPLATE_DATA_REQUEST";
export const DELETE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS =
  "DELETE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS";
export const DELETE_PUBLIC_VIEW_TEMPLATE_DATA_FAILURE =
  "DELETE_PUBLIC_VIEW_TEMPLATE_DATA_FAILURE";

export const CREATE_PUBLIC_VIEW_TEMPLATE_REQUEST =
  "CREATE_PUBLIC_VIEW_TEMPLATE_DATA_REQUEST";
export const CREATE_PUBLIC_VIEW_TEMPLATE_SUCCESS =
  "CREATE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS";
export const CREATE_PUBLIC_VIEW_TEMPLATE_FAILURE =
  "CREATE_PUBLIC_VIEW_TEMPLATE_DATA_FAILURE";
export const RESET_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS =
  "RESET_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS";

export const LOAD_SHOP_ORDERS_REQUEST = "LOAD_SHOP_ORDERS_REQUEST";
export const LOAD_SHOP_ORDERS_SUCCESS = "LOAD_SHOP_ORDERS_SUCCESS";
export const LOAD_SHOP_ORDERS_FAILURE = "LOAD_SHOP_ORDERS_FAILURE";

export const ADD_SHIPPING_RANGE_REQUEST = "ADD_SHIPPING_RANGE_REQUEST";
export const ADD_SHIPPING_RANGE_SUCCESS = "ADD_SHIPPING_RANGE_SUCCESS";
export const ADD_SHIPPING_RANGE_FAILURE = "ADD_SHIPPING_RANGE_FAILURE";
export const UPDATE_SHIPPING_RANGE_REQUEST = "UPDATE_SHIPPING_RANGE_REQUEST";
export const UPDATE_SHIPPING_RANGE_SUCCESS = "UPDATE_SHIPPING_RANGE_SUCCESS";
export const UPDATE_SHIPPING_RANGE_FAILURE = "UPDATE_SHIPPING_RANGE_FAILURE";
export const DELETE_SHIPPING_RANGE_REQUEST = "DELETE_SHIPPING_RANGE_REQUEST";
export const DELETE_SHIPPING_RANGE_SUCCESS = "DELETE_SHIPPING_RANGE_SUCCESS";
export const DELETE_SHIPPING_RANGE_FAILURE = "DELETE_SHIPPING_RANGE_FAILURE";

export const DELETE_PARTIAL_SUCCESS = "DELETE_PARTIAL_SUCCESS";
export const UPDATE_PRODUCT_ITEMS_SUCCESS = "UPDATE_PRODUCT_ITEMS_SUCCESS";

export const CREATE_SHOP_SUCCESS = "CREATE_SHOP_SUCCESS";

export const UPDATE_SHOP_SUCCESS_FLAT_ARRAY = "UPDATE_SHOP_SUCCESS_FLAT_ARRAY";

export const GET_FAILED_CHECKOUTS_FOR_SHOP_SUCCESS = "GET_FAILED_CHECKOUTS_FOR_SHOP_SUCCESS";
export const GET_ALL_SHOP_VARIANTS_SUCCESS = 'GET_ALL_SHOP_VARIANTS_SUCCESS';
export const DELETE_FAILED_CHECKOUTS_SUCCESS = "DELETE_FAILED_CHECKOUTS_SUCCESS";

const finalizeCreateShop = (shop) => ({
  type: CREATE_SHOP_SUCCESS,
  payload: {
    shop,
  },
});

export const createShop =
  (
    shop_name, client_id, aggregate, redirect, public_view_template_id,
    isCustomize = false, is_headless = 0, external_store_type = '', shop_type = ''
  ) => (dispatch) => {
    return oauth("POST", "shop", {
      shop_name, client_id, aggregate, public_view_template_id, is_headless, external_store_type, shop_type
    }).then(
      ({ json }) => {
        if (!redirect) {
          dispatch(finalizeCreateShop(json.shop));
          dispatch(closePopup(2));
          dispatch(createDeleteTemp("create_shop"));
          return;
        }
        window.location = isCustomize
        ? `/shop/${json.shop.shop_number}/storefront`
        : `/shop/${json.shop.shop_number}`;
      },
      ({ json }) => false
    );
  };

const requestUpdateShop = (shop_id, field, previous_value, value) => ({
  type: UPDATE_SHOP_REQUEST,
  payload: {
    id: shop_id,
    data: {
      [field]: value,
    },
  },
});

export const finalizeUpdateShop = (
  shop_id,
  field,
  previous_value,
  value,
  response
) => ({
  type: UPDATE_SHOP_SUCCESS,
  payload: {
    id: shop_id,
    data: {
      [field]: value,
    },
    response,
  },
});

export const finalizeUpdateShopFlatArray = (shop_id, field, value) => ({
  type: UPDATE_SHOP_SUCCESS_FLAT_ARRAY,
  payload: {
    id: shop_id,
    data: {
      [field]: value,
    },
  },
});

const failedUpdateShop = (shop_id, field, previous_value, value) => ({
  type: UPDATE_SHOP_FAILURE,
  payload: {
    id: shop_id,
    message: "Unable to update shop",
    data: {
      [field]: previous_value,
    },
  },
});

export const updateShop =
  (shop_id, field, previous_value, value) => (dispatch) => {
    dispatch(requestUpdateShop(shop_id, field, previous_value, value));

    return oauth("PUT", `shop/${shop_id}`, { [field]: value }).then(
      ({ json }) => {
        dispatch(
          finalizeUpdateShop(
            shop_id,
            field,
            previous_value,
            json.shop[field],
            json
          )
        );
        if (field === "currency_id") {
          dispatch(
            finalizeUpdateShop(
              shop_id,
              "currency",
              null,
              json.shop.currency,
              json
            )
          );
        } else if (
          (field === "public_view_layout_id" ||
            field === "public_view_template_id") &&
          json.shop.template_data
        ) {
          dispatch(
            finalizeUpdateShop(
              shop_id,
              "template_data",
              null,
              json.shop.template_data,
              json
            )
          );
        }
      },
      ({ json }) => {
        if (json?.error) {
          alert(json.error);
        }
        return dispatch(
          failedUpdateShop(shop_id, field, previous_value, value)
        );
      }
    );
  };

const failedDeleteShop = (shop_id, error) => ({
  type: DELETE_SHOP_FAILURE,
  payload: {
    shop_id,
    error,
  },
  error: true,
});

export const deleteShop = (shop_id) => (dispatch) => {
  return oauth("DELETE", `shop/${shop_id}`, {}).then(
    ({ json }) => {
      window.location = "/shops.php";
    },
    ({ json }) => dispatch(failedDeleteShop(shop_id, json.error))
  );
};

const finalizeLoadShop = (payload) => ({
  type: LOAD_SHOP_SUCCESS,
  payload,
});

export const createLoadShop = (shop_id, password) => (dispatch) => {
  return oauth(
    "GET",
    "page/view-shop",
    {
      object_id: shop_id,
      password,
      public: true,
    },
    undefined,
    { logout: false }
  ).then(
    ({ json }) => {
      dispatch(createAddTemp("password", password));
      dispatch(finalizeLoadShop(json.payload));
    },
    ({ json }) => false
  );
};

const createLoadShopOrdersRequest = (shop_id) => ({
  type: LOAD_SHOP_ORDERS_REQUEST,
  payload: {
    shop_id,
  },
});

const createFinalizeLoadShopOrders = (
  shop_id,
  sales_orders,
  partials,
  invoices
) => ({
  type: LOAD_SHOP_ORDERS_SUCCESS,
  payload: {
    shop_id,
    sales_orders,
    partials,
    invoices,
  },
});

const createLoadShopOrdersFailure = (shop_id) => ({
  type: LOAD_SHOP_ORDERS_FAILURE,
  payload: {
    shop_id,
  },
});

export const loadShopOrders = (shop_id) => (dispatch) => {
  dispatch(createLoadShopOrdersRequest(shop_id));
  return oauth("GET", "order", { shop_id }).then(
    ({ json }) =>
      dispatch(
        createFinalizeLoadShopOrders(
          shop_id,
          json.sales_orders,
          json.partials,
          json.invoices
        )
      ),
    ({ json }) => dispatch(createLoadShopOrdersFailure(shop_id))
  );
};

export const createCloseCart = (shop_id) => (dispatch, getState) => {
  dispatch(createCleanCart(shop_id));
};

export const createEditCartItem =
  (shop_id, item_id, is_shop_free) => (dispatch) => {
    dispatch(createEditItem(shop_id, item_id, is_shop_free, true));
    dispatch(createAddTemp("editingCartItemId", item_id));
  };

export const createCancelEditCartItem = () => (dispatch) =>
  dispatch(createDeleteTemp("editingCartItemId"));

export const createDeleteCartItem =
  (item_id, shop_id, breakdowns=undefined) => (dispatch, getState) => {
    dispatch({
      type: DELETE_CART_ITEM,
      payload: {
        item_id,
        shop_id,
        breakdowns,
      },
    });
    return dispatch(createDeleteTemp("editingCartItemId"));
  };

export const createSaveCartItem =
  (item_id, updates) => (dispatch, getState) => {
    dispatch(createDeleteTemp("editingCartItemId"));
    const cart = getState().temp?.cart ?? {};
    return dispatch(
      createAddTemp("cart", {
        ...cart,
        items: (cart.items || []).map((i) =>
          i.item_id === item_id ? updates : i
        ),
      })
    );
  };

export const createEditItem = (
  shop_id,
  item_id,
  is_shop_free,
  updateEditingCartItemId = true,
  cart_item_id = undefined
) => ({
  type: EDIT_CART_ITEM,
  payload: {
    shop_id,
    item_id,
    cart_item_id,
    is_shop_free,
    updateEditingCartItemId,
  },
});

export const createUpdateProductQuestion = (
  metadata_id,
  label,
  value,
  parent_id,
  type,
  options
) => ({
  type: UPDATE_PRODUCT_QUESTION,
  payload: {
    metadata_id,
    label,
    value,
    parent_id,
    type,
    options,
  },
});

export const createUpdateBreakdown = (
  item_id,
  color_id,
  size_id,
  product_sku_id,
  quantity,
  is_shop_free,
  shop_id,
  allow_multiple_free_item = false,
  cartFreeItemEdited = false,
  add_quantity_with_same_breakdown = false,
  product_questions = undefined,
  update_product_questions = false,
  updated_product_questions=undefined,
) => ({
  type: UPDATE_CART_BREAKDOWN,
  payload: {
    breakdown: {
      item_id: item_id,
      color_id: color_id,
      size_id: size_id,
      product_sku_id: product_sku_id,
      quantity: parseFloat(quantity),
      product_questions: product_questions,
    },
    is_shop_free: is_shop_free,
    shop_id,
    allow_multiple_free_item,
    cartFreeItemEdited,
    add_quantity_with_same_breakdown,
    update_product_questions,
    updated_product_questions
  },
});

const createCleanCart = (shop_id) => ({
  type: CLEAN_CART,
  payload: { shop_id },
});

export const createEmptyCart = (shop_id) => ({
  type: EMPTY_CART,
  payload: { shop_id },
});

const createCheckoutRequest = (
  shop_id,
  billing_info,
  shipping_info,
  breakdowns,
  artworks,
  comment,
  customer,
  checked_out_amount,
  order_metadata,
  applied_discount,
  customer_po,
  captcha,
  items_metadata
) => ({
  type: CREATE_CHECKOUT_REQUEST,
  payload: {
    shop_id,
    billing_info,
    shipping_info,
    breakdowns,
    artworks,
    comment,
    customer,
    checked_out_amount,
    order_metadata,
    applied_discount,
    customer_po,
    captcha,
    items_metadata,
  },
});

const createCheckoutSuccess = (shop_id) => ({
  type: CREATE_CHECKOUT_SUCCESS,
  payload: {
    shop_id,
  },
});

const createCheckoutFailure = (shop_id) => ({
  type: CREATE_CHECKOUT_FAILURE,
  payload: {
    shop_id,
  },
});

export const createCheckout =
  (
    shop_id,
    billing_info,
    shipping_info,
    breakdowns,
    artworks,
    comment,
    payment_data = null,
    shipping_range_id,
    customer,
    checked_out_amount,
    order_metadata,
    applied_discount = null,
    customer_po = "",
    redirect = true,
    client_id = null,
    captcha = false,
    onRedirect = null,
    items_metadata = null,
    suppressErrorPopup = false
  ) =>
  (dispatch, getState) => {
    const shop_password = getState().temp.password;
    dispatch(
      createCheckoutRequest(
        shop_id,
        billing_info,
        shipping_info,
        breakdowns,
        artworks,
        comment,
        customer,
        checked_out_amount,
        order_metadata,
        applied_discount,
        customer_po,
        captcha,
        items_metadata
      )
    );

    const data = {
      shop_id,
      breakdowns,
      artworks,
      shop_password,
      comment,
      payment_data,
      shipping_range_id,
      customer,
      checked_out_amount,
      order_metadata,
      client_id,
      customer_po,
      captcha,
    };
    if (billing_info.contact.contact_id) {
      data.billing_contact_id = billing_info.contact.contact_id;
    } else {
      data.billing_contact = billing_info.contact;
    }
    if (billing_info.address.address_id) {
      data.billing_address_id = billing_info.address.address_id;
    } else {
      data.billing_address = billing_info.address;
    }
    if (false === shipping_info) {
      data.same_as_billing = true;
    } else {
      if (shipping_info.contact.contact_id) {
        data.shipping_contact_id = shipping_info.contact.contact_id;
      } else {
        data.shipping_contact = shipping_info.contact;
      }
      if (shipping_info.address.address_id) {
        data.shipping_address_id = shipping_info.address.address_id;
      } else {
        data.shipping_address = shipping_info.address;
      }
    }
    if (applied_discount) {
      data.applied_discount = applied_discount;
    }

    if (items_metadata) {
      data.item_metadata = items_metadata;
    }

    const buy_inventory = !!(
      getState().entities.shops[shop_id] || { buy_inventory: false }
    ).buy_inventory;
    data.buy_inventory = buy_inventory;

    return oauth("POST", "checkout", data).then(
      ({ json }) => {
        if (redirect) {
          dispatch(closePopup());
          dispatch(createEmptyCart(shop_id));
          const isCustomDomain = getState().entities.isCustomDomain === true;
          const receiptPath = isCustomDomain
            ? `/receipt`
            : `/shop/${shop_id}/receipt`;
          onRedirect?.(
            receiptPath + (buy_inventory ? "?buy_inventory=true" : "")
          );
        }

        return json;
      },
      ({ json }) => {
        dispatch(closePopup());
        if (!suppressErrorPopup) {
          const shop = getState().entities.shops?.[shop_id];
          const contactEmail = shop?.contact_email?.trim();
          const message = contactEmail
            ? `Uh oh, looks like there's a hiccup. Refresh the page and try again - if it still doesn't work, contact ${contactEmail}.`
            : `Uh oh, looks like there's a hiccup. Refresh the page and try again.`;
          dispatch(
            createErrorPopup(message)
          );
        }
        //dispatch(createCheckoutFailure(shop_id))
        return json;
      }
    );
  };

const createShippingRangeRequest = (shop_id) => ({
  type: ADD_SHIPPING_RANGE_REQUEST,
  payload: {
    shop_id,
  },
});

const createShippingRangeSuccess = (shop_id, shipping_range) => ({
  type: ADD_SHIPPING_RANGE_SUCCESS,
  payload: {
    shop_id,
    shipping_range,
  },
});

const createShippingRangeFailure = (shop_id) => ({
  type: ADD_SHIPPING_RANGE_FAILURE,
  payload: {
    shop_id,
  },
});

export const createShippingRange = (shop_id) => (dispatch) => {
  dispatch(createShippingRangeRequest(shop_id));

  const data = {
    parent_id: shop_id,
    parent_type: "SHOP",
  };

  return oauth("POST", "shipping-range", data).then(
    ({ json }) => {
      dispatch(createShippingRangeSuccess(shop_id, json.shipping_range));
    },
    ({ json }) => {
      dispatch(createShippingRangeFailure(shop_id));
    }
  );
};

const updateShippingRangeRequest = (shop_id, shipping_range_id) => ({
  type: UPDATE_SHIPPING_RANGE_REQUEST,
  payload: {
    shop_id,
    shipping_range_id,
  },
});

const updateShippingRangeSuccess = (
  shop_id,
  shipping_range_id,
  field,
  value
) => ({
  type: UPDATE_SHIPPING_RANGE_SUCCESS,
  payload: {
    shop_id,
    shipping_range_id,
    data: {
      [field]: value,
    },
  },
});

const updateShippingRangeFailure = (
  shop_id,
  shipping_range_id,
  field,
  previous_value
) => ({
  type: UPDATE_SHIPPING_RANGE_FAILURE,
  payload: {
    shop_id,
    shipping_range_id,
    data: {
      [field]: previous_value,
    },
  },
});

export const updateShippingRange =
  (shop_id, shipping_range_id, field, previous_value, value) => (dispatch) => {
    dispatch(updateShippingRangeRequest(shop_id, shipping_range_id));

    const data = {
      [field]: value,
    };

    return oauth("PUT", `shipping-range/${shipping_range_id}`, data).then(
      ({ json }) => {
        dispatch(
          updateShippingRangeSuccess(shop_id, shipping_range_id, field, value)
        );
      },
      ({ json }) => {
        dispatch(
          updateShippingRangeFailure(
            shop_id,
            shipping_range_id,
            field,
            previous_value
          )
        );
      }
    );
  };

const deleteShippingRangeRequest = (shipping_range_id, shop_id) => ({
  type: DELETE_SHIPPING_RANGE_REQUEST,
  payload: {
    shipping_range_id,
    shop_id,
  },
});

const deleteShippingRangeSuccess = (shipping_range_id, shop_id) => ({
  type: DELETE_SHIPPING_RANGE_SUCCESS,
  payload: {
    shipping_range_id,
    shop_id,
  },
});

const deleteShippingRangeFailure = (shipping_range_id, shop_id) => ({
  type: DELETE_SHIPPING_RANGE_FAILURE,
  payload: {
    shipping_range_id,
    shop_id,
  },
});

export const deleteShippingRange =
  (shipping_range_id, shop_id) => (dispatch) => {
    dispatch(deleteShippingRangeRequest(shipping_range_id, shop_id));

    return oauth("DELETE", `shipping-range/${shipping_range_id}`, {}).then(
      ({ json }) => {
        dispatch(deleteShippingRangeSuccess(shipping_range_id, shop_id));
      },
      ({ json }) => {
        dispatch(deleteShippingRangeFailure(shipping_range_id, shop_id));
      }
    );
  };

export const createFetchPublicViewTemplates = (publicViewTemplates) => ({
  type: CREATE_FETCH_PUBLIC_VIEW_TEMPLATES,
  payload: {
    publicViewTemplates,
  },
});

const createFinalizeUpdatePublicViewTemplateData = (
  parent_id,
  parent_type,
  template_data
) => ({
  type: UPDATE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS,
  payload: {
    parent_id,
    parent_type,
    template_data,
  },
});

const createFinalizeUpdatePublicViewTemplateDatas = (
  parent_id,
  parent_type,
  template_data,
  changeType = "",
  deleteNames = []
) => ({
  type: UPDATE_PUBLIC_VIEW_TEMPLATE_DATAS_SUCCESS,
  payload: {
    parent_id,
    parent_type,
    template_data,
    changeType,
    deleteNames,
  },
});

const createFinalizeDeletePublicViewTemplateData = (
  parent_id,
  parent_type,
  template_id,
  name
) => ({
  type: DELETE_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS,
  payload: {
    parent_id,
    parent_type,
    template_id,
    name,
  },
});

export const finalizeCreatePublicViewTemplate = (public_view_template) => ({
  type: CREATE_PUBLIC_VIEW_TEMPLATE_SUCCESS,
  payload: {
    public_view_template,
  },
});

export const finalizeResetPublicViewTemplateData = (parent_id, parent_type, template_data) => ({
  type: RESET_PUBLIC_VIEW_TEMPLATE_DATA_SUCCESS,
  payload: {
    parent_id,
    parent_type,
    template_data,
  },
});

export const createUpdatePublicViewTemplateData =
  (parent_id, parent_type, public_view_template_id, name, value) =>
  (dispatch, getState) =>
    oauth("POST", `public-view-template-data`, {
      parent_id,
      parent_type,
      public_view_template_id,
      name,
      value,
    }).then(({ json }) => {
      if (
        [
          "reorder-carousel-images",
          "reset-category-images",
          "reset-poster-category",
        ].includes(name)
      ) {
        return dispatch(
          createFinalizeUpdatePublicViewTemplateDatas(
            parent_id,
            parent_type,
            json.template_data,
            name,
            "reorder-carousel-images" === name ? value.delete || [] : []
          )
        );
      } else {
        return dispatch(
          createFinalizeUpdatePublicViewTemplateData(
            parent_id,
            parent_type,
            json.template_data
          )
        );
      }
    });

export const createDeletePublicViewTemplateData =
  (parent_id, parent_type, public_view_template_id, name) => (dispatch) =>
    oauth("DELETE", `public-view-template-data`, {
      parent_id,
      parent_type,
      public_view_template_id,
      name,
    }).then(({ json }) =>
      dispatch(
        createFinalizeDeletePublicViewTemplateData(
          parent_id,
          parent_type,
          public_view_template_id,
          name
        )
      )
    );

export const resetPublicViewTemplateData = (parent_id, parent_type) => (dispatch, getState) => (
  oauth(
    "POST",
    parent_type === 'SHOP' ? 'shop' : 'order',
    {
      ...(parent_type === 'SHOP' ? { shop_id: parent_id } : { order_id: parent_id }),
      action: 'discard-public-view-template-data',
    },
  ).then(({ json }) => dispatch(
    finalizeResetPublicViewTemplateData(
      parent_id,
      parent_type,
      json.template_data,
    )
  ))
);

export const createJoinOrders =
  (shop_id, job_name, client_id, order_ids) => (dispatch) =>
    oauth("POST", "project", { shop_id, job_name, client_id, order_ids }).then(
      ({ json }) => {
        dispatch(closePopup());
        dispatch(finalizeUpdateShop(shop_id, "in_aggregating", 0, 1, json));
        dispatch(
          createNoticePopup(
            "Adding checkouts is in progress. It may take a while so please grab a coffee."
          )
        );
      }
    );

export const createAddToOrder =
  (order_ids, sales_order_id, shop_id) => (dispatch) =>
    oauth("POST", "project", { order_ids, sales_order_id, action: "ADD" }).then(
      ({ json }) => {
        dispatch(closePopup());
        dispatch(finalizeUpdateShop(shop_id, "in_aggregating", 0, 1, json));
        dispatch(
          createNoticePopup(
            "Adding checkouts is in progress. It may take a while so please grab a coffee."
          )
        );
      },
      ({ json }) => {
        dispatch(closePopup());
        dispatch(
          createErrorPopup(
            json?.message ?? "Unable to add these checkouts to that project."
          )
        );
      }
    );

export const createRemovePartials = (order_ids, sales_order_id) => (dispatch) =>
  oauth("POST", "project", {
    order_ids,
    sales_order_id,
    action: "REMOVE",
  }).then(({ json }) => {
    dispatch(closePopup());
    dispatch(
      createNoticePopup(
        "Removing checkouts is in progress. It may take a while so please grab a coffee."
      )
    );
  });

const createFinalizeDeletePartial = (order_id, shop_id) => ({
  type: DELETE_PARTIAL_SUCCESS,
  payload: {
    order_id,
    shop_id,
  },
});

export const createDeletePartials = (order_ids, shop_id) => (dispatch) =>
  oauth("GET", "order/delete-partials", { order_ids, shop_id }).then(
    ({ json }) => {
      if (order_ids === "ALL") {
        order_ids = json.order_ids;
      }
      order_ids.forEach((o) =>
        dispatch(createFinalizeDeletePartial(o, shop_id))
      );
    }
  );

export const createDeleteAggregatedPartials =
  (order_ids, sales_order_id) => (dispatch) =>
    oauth("GET", "order/delete-partials", {
      order_ids,
      parent_id: sales_order_id,
    }).then(({ json }) => {
      window.location = `/sales_order.php?id=${sales_order_id}`;
    });

const createFinalizeUpdateProductItems = (item_id, json) => ({
  type: UPDATE_PRODUCT_ITEMS_SUCCESS,
  payload: {
    item_id,
    ...json,
  },
});

export const fetchProductItems = (item_id, order_id) => (dispatch) =>
  oauth("GET", `item/get-product-items`, { item_id, order_id }).then(
    ({ json }) => {
      dispatch(createFinalizeUpdateProductItems(item_id, json));
    }
  );

export const createEditCheckout = (shop_id, data) => ({
  type: EDIT_CHECKOUT,
  payload: {
    shop_id,
    data,
  },
});

export const setCart = (payload) => ({
  type: SET_CART,
  payload,
});

export const finalizeUpdatePublicViewTemplate = (publicViewTemplate, order_types) => ({
  type: UPDATE_PUBLIC_VIEW_TEMPLATE_SUCCESS,
  payload: {
    publicViewTemplate,
    order_types,
  },
});

export const deletePublicViewTemplate = (public_view_template_id) => ({
  type: DELETE_PUBLIC_VIEW_TEMPLATE_SUCCESS,
  payload: {
    public_view_template_id,
  },
});

export const createUpdateTemplate =
  (public_view_template_id, data) => (dispatch) => {
    return oauth("PUT", `public-view-template/${public_view_template_id}`, data).then(
      ({ json }) => {
        const response = dispatch(finalizeUpdatePublicViewTemplate(json.template, json.order_types));
        return response;
      }
    );
  };

export const createDeleteTemplate = (public_view_template_id) => (dispatch) => {
  return oauth("DELETE", `public-view-template/${public_view_template_id}`).then(
    ({ json }) => { dispatch(deletePublicViewTemplate(public_view_template_id));
    }
  );
};

const createFinalizegetFailedCheckoutsForShop = (shop_id, data) => ({
  type: GET_FAILED_CHECKOUTS_FOR_SHOP_SUCCESS,
  payload: {
    shop_id,
    data
  }
});
export const getFailedCheckoutsForShop = (shop_id, params = {}) => (dispatch) => {
  const data = { shop_id, ...params };
  return oauth("GET", `checkout`, data).then(
    ({json}) => {
      dispatch(createFinalizegetFailedCheckoutsForShop(shop_id, json.checkouts));
    }
  );
};

const getAllVariants = (shop_id, variants) => ({
  type: GET_ALL_SHOP_VARIANTS_SUCCESS,
  payload: {
    shop_id,
    variants,
  },
});

export const getAllShopVariants = (shop_id, order_id) => (dispatch) => {
  return oauth("GET", "item-variant", { order_id }).then(({ json }) => {
    const itemVariants = json.item_variants || [];
    dispatch(getAllVariants(shop_id, itemVariants));

    // Populate each item's variants so Item/Variants component has data before navigation
    const byItemId = {};
    for (const v of itemVariants) {
      if (!byItemId[v.item_id]) byItemId[v.item_id] = [];
      byItemId[v.item_id].push(v);
    }
    for (const [item_id, variants] of Object.entries(byItemId)) {
      dispatch(getItemVariantsSuccess(item_id, variants));
    }
  });
};

const createFinalizeDeleteFailedCheckouts = (shop_id, deleted_checkout_ids) => ({
  type: DELETE_FAILED_CHECKOUTS_SUCCESS,
  payload: {
    shop_id,
    deleted_checkout_ids
  },
});

export const createDeleteFailedCheckouts = (checkout_ids, shop_id) => (dispatch) =>
  oauth("DELETE", "checkout", { checkout_ids, shop_id }).then(
    ({ json }) => {
      dispatch(createFinalizeDeleteFailedCheckouts(shop_id, json.deleted_checkout_ids));
    }
);

export const refundForwardPayments = (payment_ids) => () =>
  oauth("POST", "forward-payments/refund", { payment_ids, delete_on_refund: true }).then(
    ({ json }) => json.results
  );

export const checkExportedStatus = (order_ids) => (dispatch) => {
  return oauth("POST", "export", {
    actionName: "check_exported_status",
    order_ids: order_ids,
  }).then(
    ({ json }) => {
      // Return the array of IDs directly so the helper can await it
      return json.exported_ids || [];
    },
    (error) => {
      console.error("Failed to check exported status:", error);
      return []; // Fail gracefully by assuming none are exported
    }
  );
};
